<template>
  <div>
    <b-breadcrumb
      class="m-0"
      v-if="pageStatus == '1'"
      style="background-color: #f8f9fa"
    >
      <b-breadcrumb-item to="/dashboard">
        <b-icon
          icon="house-fill"
          scale="1.25"
          shift-v="1.25"
          aria-hidden="true"
        />&nbsp;{{ $t("dashboard") }}
      </b-breadcrumb-item>
      <b-breadcrumb-item
        :to="'/employee-tasks/' + $store.state.selectedTaskType"
        style="text-transform: capitalize"
      >{{ $t(this.$store.state.selectedTaskType.toLowerCase()) }}
      </b-breadcrumb-item>
      <b-breadcrumb-item active>{{ $t("forms") }}</b-breadcrumb-item>
    </b-breadcrumb>
    <b-breadcrumb
      v-else
      style="background-color: #f8f9fa"
    >
      <b-breadcrumb-item
        v-if="$store.state.selectedTaskType != '/tasks'"
        to="/goverance/one"
      >{{ $t("manageEmployee") }}</b-breadcrumb-item>
      <b-breadcrumb-item
        v-if="$store.state.selectedTaskType == '/tasks'"
        :to="$store.state.selectedTaskType"
      >{{ $t("tasks") }}</b-breadcrumb-item>
      <b-breadcrumb-item
        v-else
        :to="$store.state.selectedTaskType"
      >{{ $t("employeeProfile") }}</b-breadcrumb-item>
      <b-breadcrumb-item active>{{ $t("forms") }}</b-breadcrumb-item>
    </b-breadcrumb>
    <AppLoader
      v-if="isLoading || isLoadingPageData"
      class="text-center"
      small
    />

    <div>
      <div
        style="height: 85vh; overflow-y: none"
        class="m-0"
      >
        <b-row v-if="showingIntro && taskStatus != 4 && form.isShowFormIntro">
          <b-col
            cols="8"
            offset="2"
          >
            <div class="align-middle my-5">
              <h3>
                {{
                form.formTitle
                  ? form.formTitle[selectedLanguage || "english"]
                  : "No Title"
              }}
              </h3>
              <div style="height: calc(100vh - 375px); overflow: auto">
                <p v-html="sanitizedFormIntroText"></p>
              </div>

              <b-form-checkbox
                class="text-center my-3"
                v-model="userConsent"
              >{{
              $t("questionnaires.consent")
            }}</b-form-checkbox>
              <b-button
                variant="outline-danger"
                class="mr-2"
                @click="backAction()"
              >{{ $t("back") }}</b-button>
              <!--{{$t('questionnaires.backToDashboard')}}-->
              <b-button
                variant="outline-success"
                :disabled="!userConsent"
                class="mr-2"
                @click="onClickProceed()"
              >{{ $t("questionnaires.proceed") }}</b-button>
            </div>
          </b-col>
        </b-row>

        <div
          id="training"
          v-else
        >
          <b-row class="mb-4 pt-2 px-5 pb-5">
            <b-col cols="12">
              <b-card
                style="height: calc(100vh - 220px)"
                no-body
              >
                <pdf
                  :style="{width: zoomPdf ? '100%' : '35%'}"
                  :src="pdfUrl"
                  style="height: 100vh; overflow-y: scroll; align-self: center; overflow-x: hidden;"
                  @num-pages="pageCount = $event"
                  @page-loaded="currentPage = $event"
                  :page="currentPage"
                  ref="myPdf"
                ></pdf>
              </b-card>

              <b-row>
                <b-col
                  class="text-left"
                  cols="5"
                >
                  <div class="mt-3">
                    <b-button-group>
                      <b-button
                        variant="warning"
                        v-if="currentSlideIndex > 0"
                        @click="currentSlideIndex = 0"
                      >{{ $t("training.toFirstSlide") }}</b-button>
                      <b-button
                        v-if="isLinkForm"
                        variant="outline-danger"
                        @click="onBack"
                      >{{ $t("training.toDashboard") }}</b-button>
                      <b-button
                        variant="outline-primary"
                        :disabled="inTransistion"
                        v-if="currentSlideIndex != 0"
                        @click="previousSlide"
                      >{{ $t("training.slide") }}
                        {{ currentSlideIndex }}</b-button>
                    </b-button-group>
                  </div>
                </b-col>
                <b-col cols="2">
                  <span>
                    {{ $t("training.viewing") }}
                    <b-badge variant="dark">{{
                    currentPage +
                      "/" +
                      pageCount
                  }}</b-badge>
                  </span>
                </b-col>
                <b-col
                  cols="5"
                  class="text-right"
                >
                  <div class="mt-3">
                    <b-button
                      class="text-right"
                      @click="toggleFullScreen"
                    >
                      <font-awesome-icon icon="compress" />
                    </b-button>
                    <b-button-group>
                      <b-button
                        :disabled="inTransistion"
                        variant="primary"
                        class="mx-2"
                        @click="zoomPdf = false"
                      ><i class="fas fa-search-minus"></i>
                      </b-button>
                      <b-button
                        :disabled="inTransistion"
                        variant="primary"
                        class="mx-2"
                        @click="zoomPdf = true"
                      ><i class="fas fa-search-plus"></i>
                      </b-button>
                    </b-button-group>
                    <b-button-group>
                      <b-button
                        :disabled="inTransistion"
                        variant="warning"
                        class="mx-2"
                        @click="movePrevPage"
                        v-if="
                        currentPage >
                          1
                      "
                      >{{ $t("training.prevPage") }}</b-button>
                      <b-button
                        :disabled="inTransistion"
                        variant="warning"
                        class="mx-2"
                        @click="moveNextPage"
                        v-if="
                        currentPage !=
                          pageCount
                      "
                      >{{ $t("training.nextPage") }}</b-button>
                      
                      <b-button
                        :disabled="inTransistion"
                        variant="warning"
                        @click="onOpenSignatureModal"
                        v-if="(currentPage == pageCount && taskStatus != 4) || (currentPage == pageCount && linkedForm && linkedForm.formId)"
                      >{{ $t("training.next") }}</b-button>
                    </b-button-group>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
      </div>

      <!-- signature modal -->
      <b-modal
        v-model="showSignatureModal"
        hide-header-close
        no-close-on-esc
        no-close-on-backdrop
        modal-header-close="No"
        scrollable
        :title="signatureFormTitle ? signatureFormTitle[selectedLanguage] : ''"
        size="xl"
      >
        <template v-slot:modal-footer>
          <b-button
            variant="outline-danger"
            @click="resetModal"
          >{{
          $t("training.close")
        }}</b-button>
          <b-button
            v-if="subTaskStatus != 4"
            @click="onValidateSignature"
          >{{
          $t("training.complete")
        }}</b-button>
        </template>
        <div>
          <SignaturePad
            v-if="showSig"
            class="p-5"
            :isPreview="true"
            :fieldData="signatureForm"
            :sectionIndex="0"
            :fieldIndex="1"
            :isDisabled="subTaskStatus == 4 ? 1 : pageStatus == '2' ? 1 : 0"
          />
        </div>
      </b-modal>
    </div>

    <b-modal
      v-if="!isLinkForm"
      id="historyModal"
      :cancel-title="$t('training.continue')"
      :ok-title="$t('training.fromBeginning')"
      @ok="startSlidesStart"
      no-close-on-backdrop
      v-model="showModal"
      scrollable
      :title="$t('training.continueTraining')"
    >
      <p>
        {{ $t("training.ContinueText1") }} {{ currentSlideIndex + 1 }}
        {{ $t("training.ContinueText2") }}
      </p>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import SignaturePad from "../../components/templatesConstants/signature";
import AppLoader from "../../components/Loader/Loader";
// import _ from "lodash";
import { EventBus } from "@/event-bus.js";
import { HTTP } from "../../utils/HTTP";
import imageZoom from "vue-image-zoomer";
import pdf from 'vue-pdf'
import Cryptr from "cryptr";
import DOMPurify from "dompurify";

export default {
  name: "EmployeeUserTrainingPDF",
  components: {
    SignaturePad,
    AppLoader,
    imageZoom,
    pdf,
  },
  data () {
    return {
      isLoadingPageData: false,
      showModal: false,
      isLinkForm: false,
      showSignatureModal: false,
      showSig: false,
      pageCount: 0,
      currentPage: 1,
      pdfUrl: null,
      zoomPdf: false,
      logo: {
        width: "auto",
        height: "50px",
        class: "mt-2",
      },
      isSliding: false,
      inTransistion: false, // set to true when user selects answer and auto navigates to next slide, used to hide or disable buttons
      pageIntroText: null,
      formTitle: null,
      startTraining: false,
      currentSlideIndex: 0,
      currentSlide: null,
      showingIntro: true,
      enabled: true,
      dragging: false,
      userConsent: 0,
      selected: "english",
      slides: [],
      slidesWithSelectedLanguage: [],
      signatureForm: null,
      isFullScreen: false,

      // stepper functionility
      noOfSteps: 0,
      isCompletedTraining: false,
      imgProps: {
        height: "calc(100% - 150)",
      },
      taskStatus: null,
      linkedForm: null,
      employeeId: null,
      completedTaskIds: [],
      subTaskStatus: 0,
      subTaskId: null,
      signatureFormTitle: null,
      pageStatus: null,
      taskId: null,
      onboardingId: null,
      userType: null,
    };
  },

  mounted () {
    this.slidesWithSelectedLanguage = [];
    this.userType = localStorage.getItem( "userType" );
    this.$store.state.employeeDashboardTabIndex = 0;
    this.taskId = this.$route.params.taskId;
    this.pageStatus = this.$route.params.readOnly;
    this.checkSlideIndex( this.$route.params.taskId );
  },

  beforeDestroy () {
    // this.onResetLocalData();
    document.removeEventListener( "keydown", event );
  },

  beforeRouteLeave ( to, from, next ) {
    let employeeIdActive = localStorage.getItem( "employeeId" );
    let languageInLocalStore =
      localStorage.getItem( "formDefaultLanguage" ) || "english";
    if ( languageInLocalStore ) {
      this.$store.state.selectedLanguage = languageInLocalStore;
      this.$i18n.locale = languageInLocalStore;
    }
    if ( this.taskStatus == 4 || !employeeIdActive) {
      next();
    } else {
      if ( this.fromButton ) {
        next();
      } else {
        const answer = window.confirm( this.$t( "formLeaveAlertMessage" ) );
        if ( answer ) {
          next();
        } else {
          next( false );
        }
      }
    }
  },

  created () {
    // window.addEventListener("beforeunload", this.leaving);
    let self = this;
    document.addEventListener( "keydown", function ( event ) {
      if (
        self.startTraining &&
        event.which == 39 &&
        self.currentSlideIndex + 1 != self.slidesWithSelectedLanguage.length
      ) {
        self.nextslide();
      } else if (
        self.startTraining &&
        event.which == 37 &&
        self.currentSlideIndex != 0
      ) {
        self.previousSlide();
      }
    } );
  },

  updated () { },

  watch: {
    // currentSlide ( value ) { },
  },

  computed: {
    ...mapGetters( {
      form: "form1",
      selectedLanguage: "selectedLanguage",
      isLoading: "isLoading",
    } ),
    sanitizedFormIntroText () {
      const intro = this.form.formIntroText
        ? this.form.formIntroText[this.selectedLanguage || "english"]
        : "No Title";
      return DOMPurify.sanitize(intro || "", { USE_PROFILES: { html: true } });
    },
    ...mapState( ["selectedAnswersFortrainings"] ),
  },

  methods: {
    ...mapActions( ["setLanguage"] ),
    ...mapMutations( ["UPDATE_FORM"] ),

    initializeFormData () {
      if ( this.$store.state.getUserFormSubmitArray && this.$store.state.getUserFormSubmitArray.length ) {
        this.$store.state.userFormSubmitArray = this.$store.state.getUserFormSubmitArray;
      } else {
        this.$store.state.userFormSubmitArray = [];
        // let tempForm = _.cloneDeep( this.signatureForm );
        this.$store.state.userFormSubmitArray.push( {
          elements: [],
          elementId: this.signatureForm.id,
          elementInputType: this.signatureForm.inputType,
          elementTitle: this.signatureForm.label,
          language: this.selectedLanguage,
        } );
      }
    },

    checkSlideIndex ( id ) {
      this.isLinkForm = true;
      let taskId = localStorage.getItem( "traningTaskId" );
      if ( taskId == id ) {
        this.getTrainingSchema( id );
        return;
      } else {
        localStorage.removeItem( "traningTaskId" );
        this.getTrainingSchema( id );
        return;
      }
    },
    async getTrainingSchema ( id ) {
      let token = "Bearer " + localStorage.getItem( "accessToken" );
      let result = await HTTP(
        "post",
        "api/v1/onboarding/employee/task/detail",
        {
          task_id: id,
        },
        {
          Authorization: token,
        },
        null,
        true
      );
      if ( result.data.status == 1 && result.data.task ) {
        if ( result.data.task.language ) {
          this.$store.state.selectedLanguage = result.data.task.language.toLowerCase();
          this.$i18n.locale = result.data.task.language.toLowerCase();
        }
        let form = JSON.parse( result.data.task.schema );
        let form_data = null;
        if ( result.data.task.form_data ) {
          form_data = JSON.parse( result.data.task.form_data );
        }
        if ( form_data && form_data.slideStatus ) {
          localStorage.setItem( "activeSlideIndex", form_data.slideStatus - 1 );
        } else {
          localStorage.setItem( "activeSlideIndex", 0 );
        }
        if(result.data.task.is_active) {
          const cryptr = new Cryptr("myTotalySecretKey");
          const encryptedString = cryptr.encrypt(result.data.task.is_active);
          localStorage.setItem("formStatus", encryptedString);

        }
        // this.form = form; // commented this cos it has no use in code ?
        if ( result.data.task.related_form_ids ) {
          let relatedFormIds = JSON.parse( result.data.task.related_form_ids );
          this.employeeId = result.data.task.employee_id;
          this.linkedForm = null;
          if ( relatedFormIds[0] && relatedFormIds[0].formId ) {
            this.linkedForm = relatedFormIds[0];
          }
          this.onboardingId = result.data.task.onboarding_id;
        }
        this.formTitle = form.formTitle[this.selectedLanguage];
        this.formDescription = form.formDescription[this.selectedLanguage];
        this.pageIntroText = form.formIntroText[this.selectedLanguage];
        this.slides = form.formSection[0].formElements[0].files;
        this.pdfUrl = encodeURI( form.formSection[0].formElements[0].file.english );
        // console.log(encodeURI(this.pdfUrl), 'here');
        let lang = this.selectedLanguage;
        this.slides.map( ( slide ) => {
          if ( slide[lang] ) {
            this.slidesWithSelectedLanguage.push( slide[lang] );
          }
        } );

        this.taskStatus = result.data.task.task_status;
        localStorage.setItem( "activeFormSchema", result.data.task.schema );
        localStorage.setItem( "activeTaskStatus", result.data.task.task_status );
        this.setUserFormSchemaToStore();
        let activeSlideIndex = parseInt(
          localStorage.getItem( "activeSlideIndex" + this.$route.params.taskId ) // why concat task id with side index?
        );

        this.currentSlide = this.slidesWithSelectedLanguage[0];

        if (
          activeSlideIndex &&
          activeSlideIndex < this.slidesWithSelectedLanguage.length
        ) {
          this.currentSlideIndex = activeSlideIndex;
        }
        if ( result.data.task.task_status != 0 ) {
          this.startTraining = true;
        }
        if ( result.data.task.task_status != 4 ) {
          this.onStartTraining();
          this.startTraining = true;
        }
      }
      localStorage.setItem( "traningTaskId", this.$route.params.taskId );
    },

    startSlidesStart () {
      this.currentSlideIndex = 0;
    },

    onStartTraining () {
      this.startTraining = true;
      if ( this.userType == 1 || this.userType == 2 ) {
        return;
      } else {
        this.updateTaskStatus( 1 );
      }
    },

    leaving () {
      alert( "Leaving..." );
      // window.stop();
    },

    onResetLocalData () {
      localStorage.removeItem( "activeTaskStatus" );
      localStorage.removeItem( "activeFormSchema" );
    },

    autoNextslide () {
      this.inTransistion = true;
      setTimeout( () => {
        this.nextslide();
        this.inTransistion = false;
      }, 1000 );
    },

    onBack () {
      if ( this.pageStatus == "1" ) {
        this.fromButton = true;
        this.$router.push(
          "/employee-tasks/" + this.$store.state.selectedTaskType
        );
      } else {
        this.$router.push( this.$store.state.selectedTaskType );
      }
    },
    tasksPageRoute () {
      if ( this.pageStatus == "1" ) {
        this.$router.push( "/employee-tasks/" + this.$store.state.selectedTaskType );
      } else {
        this.$router.push( this.$store.state.selectedTaskType );
      }
    },
    nextslide () {
      if ( this.currentSlideIndex + 1 < this.slidesWithSelectedLanguage.length ) {
        this.currentSlideIndex++;
        this.currentslide = this.slidesWithSelectedLanguage[
          this.currentSlideIndex
        ];
        localStorage.setItem(
          "activeSlideIndex" + this.$route.params.taskId,
          this.currentSlideIndex
        );
      }
    },

    moveNextPage () {
      if ( this.currentPage + 1 > this.pageCount ) {
      } else {
        this.currentPage += 1;
      }
    },

    movePrevPage () {
      if ( this.currentPage - 1 < 1 ) {
      } else {
        this.currentPage -= 1;
      }
    },

    onPDFZoom () {
      if ( this.zoomPdf ) {
        this.zoomPdf = false;
      } else {
        this.zoomPdf = true;
      }
    },

    async updateTaskStatus ( status ) {
      let token = "Bearer " + localStorage.getItem( "accessToken" );
      try {
        await HTTP(
          "post",
          "api/v1/governance/training/employee/task/update",
          {
            task_id: this.$route.params.taskId,
            task_status: status,
            form_type: "training",
          },
          {
            Authorization: token,
          },
          null,
          true
        );
        this.taskStatus = status;
      } catch ( error ) {
        return [error];
      }
    },

    previousSlide () {
      this.currentSlideIndex--;
      this.currentslide = this.slidesWithSelectedLanguage[
        this.currentSlideIndex
      ];
      localStorage.setItem(
        "activeSlideIndex" + this.$route.params.taskId,
        this.currentSlideIndex
      );
    },

    onOpenSignatureModal () {
      if ( this.linkedForm && this.linkedForm.formId ) {
        this.getFormSchema();
      } else {
        this.onCompleteTraining();
      }
    },

    async getFormSchema () {
      this.isLoadingPageData = true;
      let formData = {
        formId: this.linkedForm.formId,
        employeeId: this.employeeId,
        onboarding_form_versions_id: this.linkedForm.onboarding_form_versions_id,
        onboarding_id: this.onboardingId,
      };
      try {
        let result = await HTTP( "post", "api/v1/governance/training/employee/task/detail", formData
        );
        let linkedForm = JSON.parse( result.data.task.schema );
        this.signatureFormTitle = linkedForm.formSection[0].sectionTitle ? linkedForm.formSection[0].sectionTitle : linkedForm.formTitle;
        this.$store.state.getUserFormSubmitArray = [];
        this.subTaskStatus = result.data.task.task_status;
        this.subTaskId = result.data.task.id;
        this.signatureForm = linkedForm.formSection[0].formElements[0];
        console.log( "typeof result.data.task.form_data", typeof result.data.task.form_data );
        let form_data = typeof result.data.task.form_data == "string" ? JSON.parse( result.data.task.form_data ) : [];
        if ( form_data && form_data.hasOwnProperty( "user_data" ) && this.subTaskStatus == 4 ) {
          this.$store.state.getUserFormSubmitArray = form_data.user_data;
        }
        this.initializeFormData();
        this.showSignatureModal = true;
        this.onShowSig();
        this.isLoadingPageData = false;
      } catch ( error ) {
        this.isLoadingPageData = false;
        return [error];
      }
    },

    resetModal () {
      this.showSignatureModal = false;
      this.showSig = false;
    },

    onValidateSignature () {
      EventBus.$emit( "onSubmitEndUserForm", "form training" );
      this.getInvalidFields();
      // this.checkForInValidFields();
    },

    getInvalidFields () {
      if ( this.$store.state.validFields ) {
        this.onSubmitSubTask();
      } else {
        this.showSignatureModal = true;
      }
    },
    backAction () {
      if ( this.pageStatus == "1" ) {
        this.$router.push(
          "/employee-tasks/" + localStorage.getItem( "selected_task_type" )
        );
      } else {
        this.$router.push( this.$store.state.selectedTaskType );
      }
    },
    onClickProceed () {
      this.showingIntro = false;
      this.setUserFormSchemaToStore();
      let activeSlideIndex = parseInt(
        localStorage.getItem( "activeSlideIndex" + this.$route.params.taskId ) // why concat task id with side index?
      );
      if ( activeSlideIndex && activeSlideIndex > 0 ) {
        this.showModal = true;
      }
    },
    setUserFormSchemaToStore () {
      let form = JSON.parse( localStorage.getItem( "activeFormSchema" ) );
      // let taskdata = JSON.parse( localStorage.getItem( "taskFormData" ) );
      this.updateFormToStore( form );
    },

    updateFormToStore ( form ) {
      this.UPDATE_FORM( form );
    },
    async onSubmitSubTask () {
      this.resetModal();
      let userId = localStorage.getItem( "userId" );
      let taskData = this.$store.state.userFormSubmitArray;
      if ( this.taskStatus != 4 || this.subTaskStatus != 4 ) {
        this.isLoadingPageData = true;
        let token = "Bearer " + localStorage.getItem( "accessToken" );

        try {
          let result = await HTTP(
            "post",
            "api/v1/governance/training/employee/task/update",
            {
              task_id: this.subTaskId,
              task_status: 4,
              user_id: userId,
              form_data: taskData,
              form_type: "governance",
            },
            {
              Authorization: token,
            },
            null,
            true
          );
          this.fromButton = true;
          if ( result.data.status == 1 && result.status == 200 ) {
            this.onCompleteTraining();
          }
          this.isLoadingPageData = false;
        } catch ( error ) {
          this.isLoadingPageData = false;
          return [error];
        }
      } else {
        this.fromButton = true;
        // this.$router.push("/employee-trainings");
        // this.$router.push("dashboard");
      }
    },

    async onCompleteTraining () {
      let userId = localStorage.getItem( "userId" );
      let taskData = this.$store.state.userFormSubmitArray;
      let taskId = localStorage.getItem( "traningTaskId" );
      if ( this.taskStatus != 4 ) {
        this.isLoadingPageData = true;
        let token = "Bearer " + localStorage.getItem( "accessToken" );

        try {
          await HTTP(
            "post",
            "api/v1/governance/training/employee/task/update",
            {
              task_id: taskId,
              task_status: 4,
              user_id: userId,
              form_data: taskData,
              form_type: "training",
            },
            {
              Authorization: token,
            },
            null,
            true
          );
          this.fromButton = true;
          this.tasksPageRoute();
          this.isLoadingPageData = false;
        } catch ( error ) {
          this.isLoadingPageData = false;
          return [error];
        }
      } else {
        this.fromButton = true;
        this.tasksPageRoute();
      }
    },

    //method to toggle full screen mood
    toggleFullScreen () {
      if (
        ( document.fullScreenElement && document.fullScreenElement !== null ) ||
        ( !document.mozFullScreen && !document.webkitIsFullScreen )
      ) {
        if ( document.documentElement.requestFullScreen ) {
          document.documentElement.requestFullScreen();
        } else if ( document.documentElement.mozRequestFullScreen ) {
          document.documentElement.mozRequestFullScreen();
        } else if ( document.documentElement.webkitRequestFullScreen ) {
          document.documentElement.webkitRequestFullScreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if ( document.cancelFullScreen ) {
          document.cancelFullScreen();
        } else if ( document.mozCancelFullScreen ) {
          document.mozCancelFullScreen();
        } else if ( document.webkitCancelFullScreen ) {
          document.webkitCancelFullScreen();
        }
      }
    },

    onShowSig () {
      setTimeout( () => {
        this.showSig = true;
      }, 400 );
    },
  },
};
</script>

<style>
.height-images {
  height: calc(100vh - 230px);
}
/* image zoom msg start*/
.vh--message {
  background-color: rgb(116 114 114 / 65%);
  padding: 2px 12px;
  border-radius: 50px;
  text-align: center;
  line-height: initial;
}
/* end */

.preview-scrollable-wrapper {
  position: relative;
  overflow-y: auto;
  height: calc(100vh - 290px);
  /* height:400px */
}

.selectPicket {
  width: 350px;
}

.animate-slide-from-left {
  position: relative;
  animation: fromLeft 2s;
  opacity: 1;
}

.animate-slide-to-right {
  position: relative;
  animation: toRight 0.5s;
  opacity: 1;
}

@keyframes fromLeft {
  from {
    left: -50px;
    opacity: 0;
  }

  to {
    left: 0;
    opacity: 1;
  }
}

@keyframes toRight {
  from {
    left: 0;
    opacity: 1;
  }

  to {
    left: 150px;
    opacity: 0;
  }
}

.first {
  width: 20rem;
  height: 40px;
  background: #33dd97;
  position: absolute;
}

#talkbubble {
  margin-top: 45px;
  width: 20rem;
  height: 12rem;
  background: #33dd97;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}

#talkbubble:before {
  content: "";
  position: absolute;
  right: 9rem;
  top: 12rem;
  width: 0;
  height: 0;
  border-right: 12px solid transparent;
  border-top: 25px solid #33dd97;
  border-left: 12px solid transparent;
}

.modal-container {
  margin: 5px;
}
</style>
